import { extendTheme } from '@chakra-ui/react';
import {
  containerTheme,
  headingTheme,
  formLabelTheme,
  radioTheme,
  textTheme,
  buttonTheme,
  linkTheme,
  modalTheme,
  checkboxTheme,
  inputTheme,
  selectTheme,
  accordionTheme,
  formTheme,
  tooltipTheme,
  popoverTheme
} from './components';
import { fonts, fontSizes, lineHeights, spacing, sizes, colors, styles } from './defaults';
import { listTheme } from './components/list-theme';

export const customTheme = extendTheme({
  sizes,
  styles,
  fonts,
  fontSizes,
  lineHeights,
  spacing,
  colors,
  components: {
    Container: containerTheme,
    Heading: headingTheme,
    FormLabel: formLabelTheme,
    Form: formTheme,
    Radio: radioTheme,
    Text: textTheme,
    Button: buttonTheme,
    Link: linkTheme,
    Modal: modalTheme,
    Checkbox: checkboxTheme,
    Input: inputTheme,
    List: listTheme,
    Select: selectTheme,
    Accordion: accordionTheme,
    Tooltip: tooltipTheme,
    Popover: popoverTheme
  }
});
